import { getBonusMessagesHandler, getStatusHandler } from "../../../constants";
import { parseSettlementStatus } from "../../parseSettlementStatus";
const mapBetStatusToEarlyWinStatus = new Proxy({
    Open: "Active",
    Won: "Active",
    Lost: "Inactive",
    CashOut: "Forefeited",
    Cancelled: "Inactive",
    DeadHeatReduction: "Active",
    Void: "Inactive",
}, getStatusHandler);
const mapBetStatusToEarlyWinPhrases = new Proxy({
    Open: [],
    Won: [],
    Lost: ["EarlyWinNotApplied"],
    CashOut: ["EarlyWinCashedOut"],
    Cancelled: ["EarlyWinReturned"],
    DeadHeatReduction: [],
    Void: ["EarlyWinReturned"],
}, getBonusMessagesHandler);
export function parseEarlyWinBonusMessagesAndState(bet, dictionary) {
    const settlementStatus = parseSettlementStatus(bet.settlementStatus);
    const isEarlyWin = bet.selections.every(s => s.isEarlyWinSettled);
    let bonusStatus = mapBetStatusToEarlyWinStatus[settlementStatus];
    let bonusMessages = mapBetStatusToEarlyWinPhrases[settlementStatus].map(phrase => ({
        type: "Regular",
        text: dictionary.myBetsDictionary[phrase]
    }));
    if (!isEarlyWin && settlementStatus === "Won" || settlementStatus === "DeadHeatReduction") {
        bonusMessages = [{
                type: "Regular",
                text: dictionary.myBetsDictionary.EarlyWinNotApplied,
            }];
        bonusStatus = "Inactive";
    }
    return [bonusStatus, bonusMessages];
}
//# sourceMappingURL=parseEarlyWinBonusMessagesAndState.js.map